import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
  Spinner,
  Overlay,
  Table,
} from "react-bootstrap";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import OperationTable from "../../user/drone/OperationTable";
import PaginationS from "../../admin/Pagination";
import { FaRegEdit } from "react-icons/fa";

import StatusPilot from "../../user/pilot/StatusPilot";

const FightPlans = (props) => {
  const data = props.data;
  let Navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [chosenTable, setChosenTable] = useState(1);
  const [dataOperation, setDataOperation] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(true)
    }, 2000);
  }, []);

  return (
    <>
      <h2 className="profile-header">ข้อมูลบัญชี</h2>
    

    </>
  );
};

export default FightPlans;
